module.exports = __webpack_public_path__ + "static/media/goal-logo-color-3-rgb.ce4d39a3.png";